import { Mapper } from "../../../../core/base";
import { VehicleTypeWebEntity } from "./vehicle-type-web-entity";
import { VehicleType } from "../../../../core/domain";

export class VehicleTypeWebRepositoryMapper extends Mapper<VehicleTypeWebEntity, VehicleType> {
  mapFrom(param: VehicleTypeWebEntity): VehicleType {
    return {
      id: param.id,
      name: param.name,
      maxQuantity: param.maxQuantity,
      capacityType1: param.capacityType1,
      capacityType2: param.capacityType2,
      capacityType3: param.capacityType3,
      imgPath: param.imgPath,
      vehicleProfile: param.vehicleProfile,
      speedFactor: param.speedFactor
    };
  }

  mapTo(param: VehicleType): VehicleTypeWebEntity {
    return {
      id: param.id,
      name: param.name,
      maxQuantity: param.maxQuantity,
      capacityType1: param.capacityType1,
      capacityType2: param.capacityType2,
      capacityType3: param.capacityType3,
      imgPath: param.imgPath,
      vehicleProfile: param.vehicleProfile,
      speedFactor: param.speedFactor
    };
  }

}
